import PrimaryButton from '../PrimaryButton';
import { Icon } from '@iconify/react';
import closeIcon from '@iconify/icons-material-symbols/close-rounded';
import { Dialog, DialogContent } from '../Dialog';

interface Props {
  show: boolean;
  onDismiss: () => void;
  onMarkComplete: () => void;
}

const CompletionReminderModal = ({ show, onDismiss, onMarkComplete }: Props) => {
  const handleMarkComplete = () => {
    onMarkComplete();
    onDismiss();
  };

  return (
    <Dialog
      open={show}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onDismiss();
        }
      }}
    >
      <DialogContent
        className='w-[min(95vw,600px)] overflow-hidden rounded-[1.2rem] border-0 bg-white p-0 shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
        overlayClassName='bg-black/50'
        aria-labelledby='completion-reminder-title'
        aria-describedby='completion-reminder-description'
      >
        <button
          type='button'
          onClick={onDismiss}
          aria-label='Close'
          className='absolute right-[1.5rem] top-[1.5rem] inline-flex h-[2.5rem] w-[2.5rem] cursor-pointer items-center justify-center border-0 bg-transparent p-0 text-[#3f3f3f] transition-colors hover:text-[#242424] focus:outline-none focus-visible:rounded-[4px] focus-visible:ring-2 focus-visible:ring-[#2A9DCE]'
        >
          <Icon className='h-[2.5rem] w-[2.5rem]' icon={closeIcon} />
        </button>

        <div className='px-[2rem] pb-[3rem] pt-[3rem] md:px-[5rem] md:pb-[4rem] md:pt-[4rem]'>
          <div className='mb-[2.5rem] flex flex-col gap-[1.5rem] text-center'>
            <h2
              id='completion-reminder-title'
              className="m-0 font-['GT-Walsheim-Pro-Bold'] text-[1.8rem] leading-[1.3] md:text-[2.4rem]"
            >
              <span className='mr-[0.5rem]' aria-hidden='true'>
                ✨
              </span>
              All done? Let's check this off!
            </h2>
            <p
              id='completion-reminder-description'
              className="m-0 font-['GT-Walsheim-Pro-Regular'] text-[1.6rem] leading-[1.5] text-[#3f3f3f] md:text-[1.8rem]"
            >
              You've been here for a bit - click below to mark this lesson complete and keep your progress shining.
            </p>
          </div>

          <div className='flex items-center justify-center'>
            <PrimaryButton
              onClick={handleMarkComplete}
              className='min-w-[20rem] [&>button]:min-w-[20rem] [&>button]:rounded-[0.8rem] [&>button]:border-[#1aa6c9] [&>button]:bg-[#1aa6c9] [&>button]:px-[3rem] [&>button]:py-[1.2rem] [&>button]:text-[1.6rem] [&>button]:text-white [&>button]:hover:border-[#0074ab] [&>button]:hover:bg-[#0074ab]'
            >
              Mark as Complete
            </PrimaryButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CompletionReminderModal;
